module.exports = __webpack_public_path__ + "img/book-open.64024d02.svg";